import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=71cc82be&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cc82be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71cc82be')) {
      api.createRecord('71cc82be', component.options)
    } else {
      api.reload('71cc82be', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=71cc82be&scoped=true&", function () {
      api.rerender('71cc82be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JYZa1XPWxKJL/JS/comp/Accordion.vue"
export default component.exports